var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterfaceFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 4.66691C16.6666 4.2002 16.6663 3.96667 16.5754 3.78841C16.4955 3.63161 16.3685 3.50422 16.2117 3.42432C16.0335 3.3335 15.7996 3.3335 15.3329 3.3335H4.66626C4.19955 3.3335 3.96643 3.3335 3.78817 3.42432C3.63137 3.50422 3.50397 3.63161 3.42408 3.78841C3.33325 3.96667 3.33325 4.2002 3.33325 4.66691V5.28129C3.33325 5.48512 3.33325 5.58711 3.35628 5.68301C3.37669 5.76804 3.41045 5.84927 3.45614 5.92383C3.50765 6.0079 3.57984 6.08009 3.72388 6.22412L7.94283 10.4431C8.08694 10.5872 8.15862 10.6589 8.21015 10.743C8.25584 10.8175 8.29005 10.899 8.31047 10.984C8.33326 11.079 8.33325 11.1798 8.33325 11.3795V15.3427C8.33325 16.057 8.33325 16.4144 8.4837 16.6295C8.61508 16.8174 8.81776 16.9426 9.04451 16.9762C9.3042 17.0145 9.62384 16.8549 10.2628 16.5355L10.9294 16.2021C11.197 16.0684 11.3304 16.0012 11.4282 15.9014C11.5146 15.8132 11.5807 15.7072 11.621 15.5905C11.6666 15.4584 11.6666 15.3085 11.6666 15.0093V11.3857C11.6666 11.1818 11.6666 11.08 11.6896 10.984C11.71 10.899 11.7438 10.8175 11.7895 10.743C11.8407 10.6594 11.9121 10.5879 12.0543 10.4457L12.0572 10.4431L16.2762 6.22412C16.4203 6.07999 16.4919 6.00793 16.5435 5.92383C16.5892 5.84927 16.6234 5.76804 16.6438 5.68301C16.6666 5.58809 16.6666 5.48719 16.6666 5.2875V4.66691Z",
    stroke: "#616161",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceFilterIcon);
export default __webpack_public_path__ + "static/media/interfaceFilterIcon.3218db4dd1ea2368cc74f8ca05bdc2dc.svg";
export { ForwardRef as ReactComponent };